export const PERCONA_TOUR_FLAG = 'percona.showTour';
